import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { SubItem } from './components/SubItem';
import { Tariff } from './components/Tariff';

import * as arrowIcon from './static/img/arrowsIcon.svg';
import * as percentIcon from './static/img/percentIcon.svg';
import * as thresholdIcon from './static/img/thresholdIcon.svg';
import * as walletIcon from './static/img/walletIcon.svg';

export const Benefits: React.FC = () => {
  const { t } = useTranslation();
  return (
    <div className="invest-landing-section">
      <h2 className="invest-landing-section__title">
        {t('What Are the Benefits of Investing with United Traders?')}
      </h2>
      <div className="invest-landing__content">
        <div className="invest-landing-dropdown__row">
          <div className="invest-landing-section__column invest-landing-section__column_col-10 invest-landing-section__column_gap-right-2">
            <SubItem title={t('No minimum threshold')} icon={thresholdIcon}>
              {t('Stocks no minimum threshold benefit')}
            </SubItem>
          </div>
          <div className="invest-landing-section__column invest-landing-section__column_col-11">
            <SubItem
              title={t('Profit from the difference in quotes and dividends')}
              icon={arrowIcon}
            >
              {t('Stocks profit from the difference in quotes and dividends benefit')}
            </SubItem>
          </div>
        </div>
        <div className="invest-landing-dropdown__row">
          <div className="invest-landing-section__column invest-landing-section__column_col-10 invest-landing-section__column_gap-right-2">
            <SubItem title={t('Convenient')} icon={walletIcon}>
              {t('Stocks simple and convenient benefit')}
            </SubItem>
          </div>
          <div className="invest-landing-section__column invest-landing-section__column_col-11">
            <SubItem title={t('Low comission')} icon={percentIcon}>
              <Tariff />
            </SubItem>
          </div>
        </div>
      </div>
    </div>
  );
};
